/**
 * Returns the correct wrapper classname depending of field element type
 * @param {HTMLElement} element - The current HTML element
 * @returns {string} className - the classname we are looking for
 */
function findWrapperClassName(element) {
    let className;
    switch (element.type) {
        case 'select':
        case 'select-one':
            className = 'select';
            break;
        case 'radio':
            className = 'radio';
            break;
        case 'checkbox':
            className = 'checkbox';
            break;
        default:
            className = 'input';
    }
    return className;
}

/**
 * This function toggles the closest DIV wrapper element being checked
 * @param {HTMLElement} element - The current HTML element
 * @param {boolean} status - the current validity check response as a boolean
 */
function toggleErrorWrapperClass(element, status) {
    if (element.required) {
        const className = findWrapperClassName(element);
        let labelElement = '';
        if (element.closest('.form-field')) {
            labelElement = element.closest('.form-field').querySelector('label');
        } else if (element.closest('.input-wrapper')) {
            labelElement = element.parentNode.parentNode.querySelector('label');
        } else {
            labelElement = element.closest('div').querySelector('label');
        }

        const divWrapper = element.closest(`.${className}-wrapper`);

        if (className !== 'radio' && className !== 'checkbox' && className !== 'select') {
            if (status) {
                labelElement.classList.remove('error');
            } else {
                labelElement.classList.add('error');
            }
        }
        if (status) {
            divWrapper.classList.remove('error');
        } else {
            divWrapper.classList.add('error');
        }
    }
}

/**
 * Apply validity status classes to an element
 * @param {HTMLElement} inputElem - Element that contains a value and validity rules
 * @param {HTMLElement} statusElem - Element where the classes will be applied
 * @param {boolean} status - Current validity check response of inputELem
 */
function applyStatusClasses(inputElem, statusElem, status) {
    if (status) {
        statusElem.classList.remove('error');
        if (inputElem.required || inputElem.value !== '') {
            statusElem.classList.add('valid');
        } else {
            statusElem.classList.remove('valid');
        }
    } else {
        statusElem.classList.remove('valid');
        statusElem.classList.add('error');
    }
}

/**
 * This function toggles the closest DIV wrapper element being checked
 * @param {HTMLElement} element - The current HTML element
 * @param {boolean} status - the current validity check response as a boolean
 */
function toggleWrapperClass(element, status) {
    const className = findWrapperClassName(element);
    let labelElement = '';

    if (element.closest('.form-field')) {
        labelElement = element.closest('.form-field').querySelector('label');
    } else if (element.closest('.input-wrapper')) {
        labelElement = element.parentNode.parentNode.querySelector('label');
    } else {
        labelElement = element.closest('div').querySelector('label');
    }

    const divWrapper = element.closest(`.${className}-wrapper`);

    if (className !== 'radio' && className !== 'checkbox' && className !== 'select') {
        applyStatusClasses(element, labelElement, status);
    }
    applyStatusClasses(element, divWrapper, status);
}

/**
 * Removes the aria-invalid status. This is used after form posting
 * @param {HTMLElement} element - The current HTML element
 */
function removeAriaValidity(element) {
    element.removeAttribute('aria-invalid');
}

/**
 * this function reset the field wrapper class
 * it will remove the red cross or green tick. This is used after form posting
 * @param {HTMLElement} element - The current HTML element
 */
function removeWrapperClass(element) {
    const className = findWrapperClassName(element);
    const divWrapper = element.closest(`.${className}-wrapper`);
    divWrapper.classList.remove('valid');
    divWrapper.classList.remove('error'); // useless but just in case
    divWrapper.classList.remove('is-invalid'); // useless but just in case
}

/**
 * this function reset label class
 * @param {HTMLElement} element element
 */
function removeLabelClass(element) {
    const field = element.closest('.form-field');
    if (field) {
        const label = field.querySelector('label');
        if (label) {
            label.classList.remove('valid');
            label.classList.remove('error');
        }
    }
}

/**
 * this function remove the is-active class of the field that put the label on the top of the input
 * @param {HTMLElement} element element
 */
function deactivateField(element) {
    const field = element.closest('.form-field');
    if (field) {
        field.classList.remove('is-active');
    }
}

/**
 * This function toggles the element aria-invalid state
 * @param {HTMLElement} element - The current HTML element
 * @param {boolean} status - the current validity check response as a boolean
 */
function toggleAriaInvalidState(element, status) {
    element.setAttribute('aria-invalid', status);
}

/**
 * This function sets the default error message displayed to end-customer
 * @param {HTMLElement} element the current html element
 * @param {string} type the type of error message we want to display to customer
 */
function bdErrorMsg(element, type) {
    let message;
    switch (type) {
        case 'invalid':
            if (element.dataset.invalidFormat) {
                message = element.dataset.invalidFormat;
            }
            break;
        default:
            if (element.dataset.missingError) {
                message = element.dataset.missingError;
            }
    }
    document.querySelector('#bdErrorMsg').innerText = message;
    element.closest('.birthday').classList.add('error');
}

/**
 * Reset Birthday error message
 */
function resetBirthdayErrorMsg() {
    document.querySelector('#bdErrorMsg').innerText = '';
    const birthdayContainer = document.querySelector('.birthday');
    birthdayContainer.classList.remove('error');
    Array.from(birthdayContainer.children).forEach((elem) => {
        elem.classList.remove('error');
        const selectEl = elem.querySelector('select');
        if (selectEl) {
            selectEl.removeAttribute('aria-invalid');
        }
    });
}

/**
 * This function maps the itiError with dataset element as defined on the HTML element
 * see: getValidationError option
 *      https://github.com/jackocnr/intl-tel-input#initialisation-options
 * @param {HTMLElement} element the current html element
 * @param {string} itiError the error as returned by iti validator
 */
function itiFindErrorState(element, itiError) {
    let message;
    switch (itiError) {
        case 'IS_POSSIBLE':
            if (element.dataset.missingError) {
                message = element.dataset.missingError;
            }
            break;
        case 'INVALID_COUNTRY_CODE':
            if (element.dataset.missingError) {
                message = element.dataset.missingError;
            }
            break;
        case 'TOO_SHORT':
            if (element.dataset.rangeError) {
                message = element.dataset.rangeError;
            }
            break;
        case 'TOO_LONG':
            if (element.dataset.rangeError) {
                message = element.dataset.rangeError;
            }
            break;
        case 'NOT_A_NUMBER':
            if (element.dataset.patternMismatch) {
                message = element.dataset.patternMismatch;
            }
            break;
        default:
            if (element.dataset.patternMismatch) {
                message = element.dataset.patternMismatch;
            }
    }
    element.setCustomValidity(message);
}

/**
 * This function returns the error triggered for the validity check
 * Only one entry can be equal to true.
 * @param {HTMLElement} element the HTML element
 * @returns {string} the error message to be displayed
 */
function findErrorState(element) {
    // for a reason I ignore the validityState Object id not parsable
    // So we need to perform the matching manually
    let message = element.validationMessage ? element.validationMessage : '';
    const validityObj = element.validity ? element.validity : {};
    if (validityObj.valueMissing) {
        if (element.dataset.missingError) {
            message = element.dataset.missingError;
        }
    }
    if (validityObj.typeMismatch) {
        if (element.dataset.typeMismatch) {
            message = element.dataset.typeMismatch;
        }
    }
    if (validityObj.patternMismatch) {
        if (element.dataset.patternMismatch) {
            message = element.dataset.patternMismatch;
        }
    }
    if (validityObj.tooLong) {
        if (element.dataset.rangeError || element.dataset.tooLong) {
            message = element.dataset.rangeError || element.dataset.tooLong;
        }
    }
    if (validityObj.tooShort) {
        if (element.dataset.rangeError || element.dataset.tooShort) {
            message = element.dataset.rangeError || element.dataset.tooShort;
        }
    }
    if (validityObj.rangeUnderflow) {
        if (element.dataset.rangeError) {
            message = element.dataset.rangeError;
        }
    }
    if (validityObj.rangeOverflow) {
        if (element.dataset.rangeError) {
            message = element.dataset.rangeError;
        }
    }
    if (validityObj.stepMismatch) {
        if (element.dataset.stepMismatch) {
            message = element.dataset.stepMismatch;
        }
    }
    return message;
}

/**
 * This function displays the error message linked to current form field validity check
 * @param {HTMLElement} element the HTML element being checked
 * @param {boolean} status the validity status of the HTML element
 * @param {string} errorMessage error message to display,
 * if not given it will find the error message related to the element validity
 */
function toggleErrorMessage(element, status, errorMessage) {
    // Valid ; No need to set error message
    if (status) return;

    let errorContainer;

    // Try to find error container from aria-described-by
    const ariaDescribedBy = element.getAttribute('aria-describeby');
    if (ariaDescribedBy) {
        const errorContainerId = ariaDescribedBy
            .split(/\s+/) // This attribute can contains multiple IDs separated by whitespaces
            .find((id) => id.includes('-error') && document.getElementById(id));
        errorContainer = document.getElementById(errorContainerId);
    }

    // Try to find error container from current wrapper
    if (!errorContainer) {
        errorContainer = element
            .closest(`.${findWrapperClassName(element)}-wrapper`)
            ?.querySelector('.invalid-feedback');
    }

    if (!errorContainer) return;

    const msg = errorMessage || findErrorState(element);
    if (msg && msg !== ' ') {
        errorContainer.innerHTML = errorMessage || findErrorState(element);
    }
}

module.exports = {
    bdErrorMsg,
    resetBirthdayErrorMsg,
    itiFindErrorState,
    removeAriaValidity,
    removeWrapperClass,
    removeLabelClass,
    deactivateField,
    toggleAriaInvalidState,
    toggleErrorMessage,
    toggleWrapperClass,
    toggleErrorWrapperClass,
};
